import { useTitleOwnerQuery } from "react-migration/domains/ownership/apollo/useTitleOwnerQuery";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { LayerTypeSelectionHeaderProps } from "../../types";
import { GeometryIcon } from "react-migration/layouts/map/Ownership/icons";
import { CardTitle } from "react-migration/components/CardTitle";

export function OwnershipTitleSelectionHeader({ selection }: Readonly<LayerTypeSelectionHeaderProps>) {
  const { t } = useTranslation();
  const { titleOwner } = useTitleOwnerQuery(selection?.id);

  return (
    <div className="flex flex-row items-start gap-x-2">
      <div>
        <GeometryIcon />
      </div>
      <div className="flex flex-col items-start grow">
        <div className="text-xs font-semibold text-text-base-tertiary">{t("selection.ownership_title")}</div>
        <div className="text-sm font-semibold text-text-base-primary">{titleOwner?.parcel_identifier}</div>
      </div>
    </div>
  );
}

export function OwnershipParcelSelectionHeader({ selection }: Readonly<LayerTypeSelectionHeaderProps>) {
  const { t } = useTranslation();
  const { titleOwner, loading } = useTitleOwnerQuery(selection?.titleNumber);

  return (
    <div className="flex flex-row items-start gap-x-2">
      <div>
        <GeometryIcon />
      </div>
      <div className="flex flex-col items-start grow">
        <div className="text-xs font-semibold text-text-base-tertiary">{t("selection.ownership_parcel_title")}</div>
        {!loading && (
          <div className="text-sm font-semibold text-text-base-primary">
            {titleOwner?.parcel_identifier
              ? t("selection.ownership_parcel_identifier", {
                  id: titleOwner?.parcel_identifier,
                })
              : t("selection.ownership_parcel_unknown")}
          </div>
        )}
      </div>
    </div>
  );
}

export function OwnerSelectionHeader({ selection }: Readonly<LayerTypeSelectionHeaderProps>) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start">
      <div className="flex flex-col items-stretch grow">
        <div className="text-xs font-semibold text-text-base-tertiary">{t("selection.owner_title")}</div>
        <div className="text-sm font-semibold text-text-base-primary">{selection?.id}</div>
      </div>
    </div>
  );
}

export function OwnerSelectionTitle() {
  return <CardTitle>Ownership</CardTitle>;
}
